<script>
import { actions } from '@utils'
import { intoSequentialPromise } from '@utils/async'
import { propEq } from 'rambda'

export default {
  data() {
    return {
      isCreatingOverview: false,
    }
  },
  methods: {
    async generateProsConsForLaptop(laptopId) {
      const { laptopEvaluations } = this

      const laptop = laptopEvaluations
        .find(propEq('id', laptopId))

      const laptopProsCons = await this.createLaptopOverview(laptop)

      this.setArticleLaptop(laptopId, laptopProsCons)
    },
    createLaptopOverview(laptop) {
      return this.$wrap(
        () => this.CREATE_LAPTOP_OVERVIEW({
          articleId: this.article.id,
          laptop,
          topic: this.article.topic,
        }),
        'isCreatingOverview',
      )
    },
    fillProsConsForSelectedLaptops() {
      const { articleLaptops } = this

      return articleLaptops
        .map(({ laptopId }) => () => this
          .generateProsConsForLaptop(laptopId))
        .reduce(intoSequentialPromise, [])
    },
    ...actions('CREATE_LAPTOP_OVERVIEW'),
  },
  render: () => '',
}
</script>
